import { Category } from '~/models/Category.models';
import type { ListingProduct } from '~/models/ListingProduct.api.model';

export const filter_productCardsByPlanVariant = (
  products: ListingProduct[],
  planId: number,
  amountMonthlyPayments: number,
  bindingPeriodMonths: number,
): ProductCard[] => {
  if (!products || !Array.isArray(products) || products.length === 0) {
    return [];
  }

  const productCards = mapListingProductsToProductCardModel(products);
  if (productCards.length === 0) {
    return [];
  }

  return productCards.filter((variant) => {
    if (variant.product.Category === Category.phones) {
      const variantPlanId = variant.bundlePrice?.Plan?.PlanId ?? -1;
      const variantPaymentTime = variant.payment.Time ?? -1;
      const variantBindingPeriodMonths =
        variant.bundlePrice?.BindingPeriod?.Months ?? -1;

      return (
        variantPlanId === planId &&
        variantPaymentTime === amountMonthlyPayments &&
        variantBindingPeriodMonths === bindingPeriodMonths
      );
    }
    return true;
  });
};
